<template>
  <section class="pd-section">
    <header v-if="title" class="pd-section__title">{{ title }}</header>
    <div class="pd-section__body">
      <slot />
    </div>
  </section>
</template>
<script>
// Tarjeta con título para agrupar campos en el detalle de un pago.
export default {
  name: "PaymentDetailSection",
  props: {
    title: { type: String, default: "" }
  }
};
</script>
<style scoped>
.pd-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  min-width: 0;
}
.pd-section__title {
  padding: 10px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #4b5563;
}
.pd-section__body {
  padding: 4px 16px;
}
</style>
